import axios from "axios";
import { getTransactionId } from "../transactionId";

const getDomainDetails = (payload, token, signal) => {
  return axios.request({
    method: "POST",
    url: "/api/GetDomainDetails",
    data: payload,
    headers: {
      "X-CSRF-Token": token,
      "X-Transaction-ID": getTransactionId(),
    },
    withCredentials: true,
    signal,
  });
};

export default getDomainDetails;